import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[formLandingHeader]',
    standalone: false
})
export class FormLandingHeaderDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
